import { useDispatch, useSelector } from 'react-redux';
import { HIDE_MESSAGE } from '~/actions';
import { createErrorObjectSelector } from '~/api/selectors';

export default function useIsError(actions: string[] = []) {
  const dispatch = useDispatch();
  const errorSelector = createErrorObjectSelector(actions);

  const errorObj = useSelector((state) => errorSelector(state));

  const clearError = () => {
    dispatch({ type: HIDE_MESSAGE, payload: actions });
  };

  return {
    selector: errorSelector,
    isError: !!errorObj?.error,
    clearError,
  };
}
